export default __webpack_public_path__ + "static/media/rabbit.be431ac9.svg";